import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import handleClipboard from '@/utils/clipboard'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { calcTimeRange } from '@/class/cargo/model/parameters/RouteConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { Job } from '@/class/model/booking/Job'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { Flight } from '@/class/model/booking/Flight'
import { queryJobMBL } from '@/api/booking/job'
import { updateFlight } from '@/api/booking/flight'
import { batchUpdate } from '@/api/AirExport/airExportJob'
import { queryFlights } from '@/api/booking/flight'
import { updateCargoDoc } from '@/api/seaExport/cargoDoc'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  methods: {
    getColumnDefs() {
      const result = [
        {
          children: [
            {
              headerName: this.$t('SeaExport.ConsignationCompany'),
              field: 'customerId',
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              },
              width: 120
            }, {
              headerName: this.$t('SeaExport.BookingAgent'),
              field: 'bookingAgent',
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              },
              width: 120
            }, {
              headerName: this.$t('SeaExport.Mbl2'),
              field: 'mbl',
              cellRenderer: params => {
                const data = params.data
                if (data.dataType === 3 || data.dataType === 4) {
                  return ColumnUtils.mawbNoLabelFun(params.value)
                } else if (data.dataType === 5) {
                  return data.warehouseNo
                }
                return ''
              },
              width: 100
            }, {
              headerName: this.$t('SeaExport.PortOfLoading'),
              field: 'loadingPortCode',
              width: 100,
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('SeaExport.PortOfDestination'),
              field: 'destinationPortCode',
              width: 100,
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('SeaExport.WarehouseNo'),
              field: 'warehouseNo',
              width: 100
            }, {
              headerName: this.$t('SeaExport.SoNo'),
              field: 'soNo',
              width: 120
            }
          ]
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignation'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityContract',
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 0, true)
              },
              width: 100
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightContract',
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 1, true)
              },
              width: 100
            }, {
              headerName: this.$t('SeaExport.Volume'),
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 3, true)
              },
              field: 'cubageContract',
              width: 100
            }
          ]
        }, {
          headerName: this.$t('SeaExport.Actual'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityActual',
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 0, true)
              },
              width: 100
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightActual',
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 1, true)
              },
              width: 100
            }, {
              headerName: this.$t('SeaExport.Volume'),
              field: 'cubageActual',
              cellRenderer: params => {
                return ColumnUtils.formatNumber(params.value, 3, true)
              },
              width: 100
            }
          ]
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Airline'),
          field: 'planner',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CartonQuantity'),
          field: 'containerDesc',
          width: 100
        }, {
          headerName: this.$t('SeaExport.OperationRequirements'),
          field: 'operationContent',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ClientsRequirement'),
          field: 'satisfiedRequests',
          width: 100
        }, {
          headerName: this.$t('SeaExport.CustomsDeclaration'),
          field: 'customs',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.yesOrNoFun(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.LandCarriage'),
          field: 'landTransportation',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.yesOrNoFun(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Storage'),
          field: 'warehousing',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.yesOrNoFun(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 100
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 100
        }
      ]
      return result
    },
    onTimeRangeChange() {
      const dateArray = calcTimeRange(this.timeRange)
      if (dateArray) {
        this.commonFilter.start = dateArray[0]
        this.commonFilter.end = dateArray[1]
      }
    },
    // 高级查询
    toAdvancedQuery(data, operator = '') {
      if (data) {
        this.advanceQueryConditions = data
      }
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'flight.ETD', `type=date,start=${this.commonFilter.start} 00:00:00,end=${this.commonFilter.end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json(),
          new AdvancedSearchOption(null, 'job.ETD', `type=date,start=${this.commonFilter.start} 00:00:00,end=${this.commonFilter.end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json()
        ],
        branchId: this.$store.getters.currentOfficeId,
        lob: 'SE'
      }
      if (this.commonFilter.regions.length > 0) {
        filter.conditions.push(new AdvancedSearchOption(null, 'port.REGION', this.commonFilter.regions, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      if (this.isAdvancedQuery) {
        filter.conditions.push(...this.advanceQueryConditions)
      }
      var loading = getLoading()
      this.loading = true
      queryFlights(filter).then(res => {
        this.originRowData = res.data // 保存原始行数据
        this.groupingJobByFlight(this.originRowData)
        this.quantityActual = 0
        this.weightActual = 0
        this.cubageActual = 0
        this.quantityContract = 0
        this.weightContract = 0
        this.cubageContract = 0
        for (const item of this.originRowData) {
          if (item.dataType === 1) {
            this.quantityActual += item.quantityActual
            this.weightActual += item.weightActual
            this.cubageActual += item.cubageActual
            this.quantityContract += item.quantityContract
            this.weightContract += item.weightContract
            this.cubageContract += item.cubageContract
          }
        }
        this.gridApi.clearFocusedCell()
        this.oldMblNo = this.mblNo
        this.mblNo = ''
        if (operator !== 'timer') {
          this.resetTimer()
        }
      }).finally(() => {
        this.loading = false
        loading.close()
      })
    },
    groupingJobByFlight(data) {
      data.sort((a, b) => a.dataType - b.dataType)
      const map = new Map()
      for (const item of data) {
        if (item.dataType === 2) {
          item.children = []
          map.set(item.path, item.children)
        } else if (item.dataType === 3 || item.dataType === 4) {
          const pathes = item.path.split(',')
          const children = map.get(pathes[0] + ',' + pathes[1])
          children.push(item)
        }
      }
    },
    resetTimer() {
      LocalStorageUtils.setConfiguration('ROUTE_CENTRAL_AUTO_REFRESH', this.autoRefresh)
      this.closeTimer()
      if (this.autoRefresh) {
        this.timerId = setInterval(() => {
          if (!this.hasPopup()) {
            this.toAdvancedQuery(null, 'timer')
          }
        }, 5 * 60 * 1000)
      }
    },
    // 判断页面是否有弹窗
    hasPopup() {
      for (const item of this.$children) {
        if (item.$children[0].$options.name === 'ElDialog' && item.$children[0].visible) {
          return true
        }
      }
      const msgBoxs = document.getElementsByClassName('el-message-box__wrapper')
      for (const item of msgBoxs) {
        if (item.style.display !== 'none') {
          return true
        }
      }
      return false
    },
    // 查看
    toLook(e) {
      stopBubble(e)
      if (!this.$checkPermission(['module_fmBookingNew'])) {
        this.$message.info('对不起!您没有权限查看详细信息.')
        return
      }
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      this.$router.push({
        name: 'SeaBooking',
        params: {
          view: 'detail',
          action: 'look',
          jobUuid: row.uuid
        }
      })
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      const job = {
        uuid: row.uuid,
        jobNo: row.jobNo,
        masterFlag: row.masterFlag,
        lclMasterUuid: row.masterFlag,
        lob: row.lob
      }
      this.templateSelectorDialog.ctx = new Job(job)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': job.uuid }
      this.templateSelectorDialog.visible = true
    },
    bookingHandler() {
      this.bookingDialog.flight = this.selectedRow
      this.bookingDialog.jobs = this.selectedRow.children
      this.bookingDialog.visible = true
    },
    exportTemplateHandler(template) {
      if (this.selectedRow.children.length === 0) {
        this.$message.info(this.$t('queryJob.flightInformationEmpty'))
        return
      }
      const jobKeyList = Array.from(this.selectedRow.children, item => item.uuid)
      this.templateSelectorDialog.ctx = new Flight(this.selectedRow)
      this.templateSelectorDialog.category = template
      this.templateSelectorDialog.data = { JOB_UUID: jobKeyList.join(','), jobIdList: jobKeyList, flightId: this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    getParentRow(row) {
      const pathItems = row.path.split(',')
      pathItems.splice(pathItems.length - 1)
      const parentPath = pathItems.join(',')
      return this.rowData.find(p => p.path === parentPath)
    },
    getSelectedJobs() {
      return this.selectedRows.filter(p => p.dataType === 3 || p.dataType === 4)
    },
    // 延迟更新按钮状态，避免频繁执行
    delayUpdateButtonState() {
      setTimeout(seq => {
        if (seq >= this.updateBtnStateSeq) {
          this.updateButtonState()
        }
      }, 100, ++this.updateBtnStateSeq)
    },
    updateButtonState() {
      const items = this.selectedRows
      let flag = items.length > 0
      let flight = null
      let isAllJob = items.length > 0
      for (const item of items) {
        isAllJob = item.dataType === 3 || item.dataType === 4
        const parentItem = this.getParentRow(item)
        if (parentItem.dataType === 3 || parentItem.dataType === 4) { // AirExportJob
          flag = false
          break
        }
        if (item.dataType === 1) { // 日期
          flag = false
          break
        }
        if (item.dataType === 2) { // Flight
          flag = false
          break
        }
        if (!flight) {
          flight = parentItem
        } else if (flight !== parentItem) {
          flag = false
          break
        }
      }
      const selectedJob = this.curDataType === 3 || this.curDataType === 4 ? this.selectedRow : null
      const selectionJobs = this.getSelectedJobs()

      this.btLoadingEnabled = flag
      this.btFlightStateLabel = '锁定航班'
      this.btFlightStateEnabled = false
      this.btDeliveryAgentEnabled = isAllJob

      /* 重置flag、flight */
      flag = false
      flight = null

      if (this.curDataType === 2) {
        flight = this.selectedRow
        if (flight.settleState === 0 && flight.uuid) {
          this.btFlightStateEnabled = this.$checkPermission(['button_AERouteCentral_LockFlight'])
        } else if (flight.settleState === 1 && flight.uuid) {
          this.btFlightStateLabel = this.$t('queryJob.unlockFlight')
          this.btFlightStateEnabled = this.$checkPermission(['button_AERouteCentral_UnlockFlight'])
        } else if (flight.uuid) {
          this.btFlightStateLabel = this.$t('queryJob.unlockFlight')
          this.btFlightStateEnabled = false
        }
      }

      flag = flight && flight.uuid && flight.children && flight.children.length > 0
      this.btBookingDoneEnabled = flag && flight.settleState === 0
      this.btPullInEnabled = flag && flight.settleState === 0
      this.btAdjustFlightEnabled = flag && flight.settleState === 0
      this.btMixFlightEnabled = selectionJobs.length > 0
      this.btCheckBookingEnabled = selectionJobs.length > 0
      this.btCancelCheckBookingEnabled = selectionJobs.length > 0
      this.btTakeOffEnabled = flag
      this.btArrivalEnabled = flag
      this.btDeliveryEnabled = flag

      if (items.length === 1 && selectedJob) {
        this.btDeclareCustomsEnabled = true
        this.btCopyWarehouseInfoEnabled = true
        let parent = this.getParentRow(selectedJob)
        if (parent.dataType === 3) {
          parent = this.getParentRow(parent)
        }
        flag = (parent && parent.dataType === 2 && (parent.uuid && parent.settleState === 0 || !parent.uuid))
        this.btBookingInEnabled = flag
        this.btOperatorRemarksEnabled = true
        this.btOtherWarehouseNotesEnabled = true
        this.btOtherChargesEnabled = true
        this.btSiteRemarkEnabled = true
        const billFlagMBL = flag && (selectedJob.masterFlag || selectedJob.operateType === AirExportConstants.BACK_TO_BACK.code || selectedJob.operateType === AirExportConstants.DIRECT.code)
        this.btBillingMAWBEnabled = billFlagMBL
        if (billFlagMBL) {
          new AirExportJob(selectedJob).getCargoDoc(CargoDocConsts.MAWB, false).then(cargoDoc => {
            this.btPrintMAWBEnabled = cargoDoc && cargoDoc.state === 5
          })
        } else {
          this.btPrintMAWBEnabled = false
        }
        const billHBL = flag && !selectedJob.masterFlag && selectedJob.operateType !== AirExportConstants.DIRECT.code
        this.btBillingHAWBEnabled = billHBL
        if (billHBL) {
          new AirExportJob(selectedJob).getCargoDoc(CargoDocConsts.HAWB, false).then(cargoDoc => {
            this.btPrintHAWBEnabled = cargoDoc && cargoDoc.state === 5
          })
        } else {
          this.btPrintHAWBEnabled = false
        }
        this.btUploadLoadingPicEnabled = Boolean(selectedJob.airExportLoadingNotes)
      } else {
        this.btBookingInEnabled = false
        this.btDeclareCustomsEnabled = false
        this.btOperatorRemarksEnabled = false
        this.btOtherWarehouseNotesEnabled = false
        this.btOtherChargesEnabled = false
        this.btSiteRemarkEnabled = false
        this.btBillingHAWBEnabled = false
        this.btBillingMAWBEnabled = false
        this.btPrintHAWBEnabled = false
        this.btPrintMAWBEnabled = false
        this.btUploadLoadingPicEnabled = false
        this.btCopyWarehouseInfoEnabled = false
      }
    },
    menuBarItemClickHandler(index) {
      switch (index) {
        case 'btBookingDone':
          this.bookingDone()
          break
        case 'btBookingIn':
          this.bookingIn()
          break
        case 'btLoading':
          this.loadingBoard()
          break
        case 'btTakeOff':
          this.updateFlight(0)
          break
        case 'btArrival':
          this.updateFlight(1)
          break
        case 'btDelivery':
          this.updateFlight(2)
          break
        case 'btDeliveryAgent':
          this.deliveryAgent()
          break
        case 'btBillingMAWB':
          this.billing('MAWB')
          break
        case 'btBillingHAWB':
          this.billing('HAWB')
          break
        case 'btPrintMAWB':
          this.printCargoDoc('MAWB')
          break
        case 'btPrintHAWB':
          this.printCargoDoc('HAWB')
          break
        case 'btDeclareCustoms':
          this.declareCustomers()
          break
        case 'btSiteRemark':
        case 'btOperatorRemarks':
        case 'btOtherWarehouseNotes':
        case 'btOtherCharges':
          this.operatorRemarks(index)
          break
        case 'btUploadLoadingPic':
          this.uploadLoadingPic()
          break
        case 'btFlightState':
          this.lockFlight()
          break
        case 'btCopyWarehouseInfo':
          this.copyWarehouseInfo()
          break
        case 'btLabel':
          this.warehouseLabel()
          break
        case 'btMixFlight':
          this.mixFlight()
          break
        case 'btCheckBooking':
          this.checkBookingState()
          break
        case 'btCancelCheckBooking':
          this.cancelCheckBookingState()
          break
        default:
          break
      }
    },
    bookingDone() {
      this.bookingDoneDialog.flight = this.selectedRow
      this.bookingDoneDialog.visible = true
    },
    bookingIn() {
      this.warehouseEntryDialog.job = this.selectedRow
      this.warehouseEntryDialog.visible = true
    },
    loadingBoard(e) {
      if (e) {
        stopBubble(e)
        this.loadingNoteDialog.jobs = [this.selectedRow]
      } else {
        this.loadingNoteDialog.jobs = this.getSelectedJobs()
      }
      this.loadingNoteDialog.visible = true
    },
    // 高配航班
    mixFlight() {
      this.mixFlightDialog.jobs = this.getSelectedJobs()
      this.mixFlightDialog.visible = true
    },
    // 确认配舱
    checkBookingState() {
      const jobs = this.getSelectedJobs()
      if (jobs.length === 0) {
        return
      }
      this.$confirm(this.$t('queryJob.confirmThis') + '【' + jobs.length + '】' + this.$t('queryJob.cabinAllocationStatusConfirmed'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const item of jobs) {
          item.bookingState = AirExportConstants.BOOKING_STATE_CONFIRMED.code
        }
        batchUpdate(jobs, { selectiveType: 'bookingState' }).then(res => {
          for (const item of res.data) {
            const job = jobs.find(p => p.uuid === item.uuid)
            if (job) {
              job.bookingState = item.bookingState
              job.version = item.version
            }
          }
          this.gridApi.refreshCells({ force: true })
          this.$message.success(this.$t('queryJob.confirmationSucceeded'))
        })
      }).catch(() => {
        this.toAdvancedQuery()
      })
    },
    // 取消确认配舱
    cancelCheckBookingState() {
      const jobs = this.getSelectedJobs()
      if (jobs.length === 0) {
        return
      }
      this.$confirm(this.$t('AirExport.ConfirmThis') + '【' + jobs.length + '】' + this.$t('queryJob.cabinAllocationStatusUnconfirmed'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const item of jobs) {
          item.bookingState = AirExportConstants.BOOKING_STATE_NORMAL.code
        }
        batchUpdate(jobs, { selectiveType: 'bookingState' }).then(res => {
          for (const item of res.data) {
            const job = jobs.find(p => p.uuid === item.uuid)
            if (job) {
              job.bookingState = item.bookingState
              job.version = item.version
            }
          }
          this.gridApi.refreshCells({ force: true })
          this.$message.success(this.$t('Message.CancelSuccessfully') + '!')
        })
      }).catch(() => {
        this.toAdvancedQuery()
      })
    },
    // 复制进仓数据
    copyWarehouseInfo() {
      if (this.curDataType === 3 || this.curDataType === 4) {
        const job = this.selectedRow
        const header = '回单号' + '\t' + this.$t('CargoMsg.Cargo_WarehouseNo') + '\t' + this.$t('SeaExport.Piece') + '\t' + this.$t('queryJob.hair') + '\t' + this.$t('SeaExport.Volume') + '\t' + this.$t('queryJob.size') + '\n'
        let info = ''
        for (const item of job.warehouseIn) {
          if (info.length > 0) {
            info += '\n'
          }
          info += item.receiptNo + '\t'
          info += item.warehouseNo + '\t'
          info += item.quantitySum + '\t'
          info += item.weightSum.toFixed(1) + '\t'
          info += item.cubageSum.toFixed(3) + '\t'
          let size = ''
          for (const subItem of item.warehouseInDetail) {
            if (size.length > 0) {
              size += ','
            }
            size += subItem.dimension
          }
          info += size
        }
        handleClipboard(header + info, window.event)
      }
    },
    queryJobMbl() {
      this.queryMblDialog.visible = true
    },
    queryMblCallback(mbl) {
      this.loading = true
      queryJobMBL({ mbl, lob: 'AE', branch: this.$store.getters.currentOfficeId }).then(res => {
        this.loading = false
        if (res.data.length > 0) {
          this.oldMblNo = this.mblNo
          this.mblNo = res.data[0].mbl
          this.toAdvancedQuery()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    declareCustomers() {
      this.declareCustomsDialog.job = this.selectedRow
      this.declareCustomsDialog.visible = true
    },
    operatorRemarks(operatorId) {
      this.operatorRemarkDialog.operatorId = operatorId
      this.operatorRemarkDialog.job = this.selectedRow
      this.operatorRemarkDialog.visible = true
    },
    updateFlight(operation) {
      this.updateFlightDialog.operation = operation
      this.updateFlightDialog.flight = this.selectedRow
      this.updateFlightDialog.visible = true
    },
    deliveryAgent() {
      this.deliverAgentDialog.jobs = this.selectedRows
      this.deliverAgentDialog.visible = true
    },
    uploadLoadingPic() {
      this.uploadLoadingPicDialog.job = this.selectedRow
      this.uploadLoadingPicDialog.visible = true
    },
    warehouseLabel() {
      const warehouseRow = this.selectedRow
      const pathItems = warehouseRow.path.split(',')
      pathItems.splice(pathItems.length - 1)
      const parentPath = pathItems.join(',')
      const job = this.rowData.find(p => p.path === parentPath)
      const warehouseIn = job.warehouseIn.find(p => p.uuid === warehouseRow.uuid)
      this.warehouseLabelDialog.job = job
      this.warehouseLabelDialog.warehouseIn = warehouseIn
      this.warehouseLabelDialog.visible = true
    },
    onWarehouseLabelChange(label) {
      this.selectedRow.label = label
      this.gridApi.setRowData(this.rowData)
    },
    billing(docType) {
      this.billingDialog.job = this.selectedRow
      this.billingDialog.docType = docType
      this.billingDialog.visible = true
    },
    async printCargoDoc(docType) {
      const job = this.selectedRow
      const cargoDoc = await new AirExportJob(job).getCargoDoc(docType, false)
      if (!cargoDoc) {
        return
      }
      this.templateSelectorDialog.ctx = new AirExportJob(job)
      this.templateSelectorDialog.category = docType === CargoDocConsts.HAWB ? 'AEHAWB' : 'AEMAWB'
      this.templateSelectorDialog.data = { JOB_UUID: job.uuid, DOC_UUID: cargoDoc.uuid, cargoDocUuid: cargoDoc.uuid }
      this.templateSelectorDialog.printedCallback = event => {
        const data = { ...cargoDoc }
        data.state = 3
        updateCargoDoc(data, { selectiveType: 'state' }).then(res => {
          Object.assign(cargoDoc, res.data)
          this.delayUpdateButtonState()
        })
      }
      this.templateSelectorDialog.visible = true
    },
    // 锁定/解锁航班
    lockFlight() {
      const flight = this.selectedRow
      if (!flight) {
        return
      }
      if (flight.settleState === 0) {
        let canLock = true
        for (const job of flight.children) {
          if (job.jobState < 1 || this.job.jobState === 13) {
            canLock = false
            break
          }
        }
        if (!canLock) {
          this.$message.info(this.$t('AirExport.AllFlightMustBeLocking'))
          return
        }
        flight.settleState = 1
      } else {
        flight.settleState = 0
      }
      updateFlight(flight, { selectiveType: 'settleState' }).then(res => {
        Object.assign(flight, res.data)
        this.delayUpdateButtonState()
      })
    },
    onCollapseFlights() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (item.data.dataType === 1) {
          continue
        }
        item.expanded = false
      }
      this.gridApi.onGroupExpandedOrCollapsed()
    },
    closeTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = 0
      }
    }
  }
}
